module.exports = require("./shi-Latn.d.ts");